import * as React from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { useData } from './hooks'
import type { ActivityDetails } from '../../../typings'

type Props = {
  current?: ActivityDetails
}

export function ActivityDetailsContent(props: Props) {
  const { current } = props
  const { owner, activityType, startDate, dueDate } = useData(props)

  return (
    <Box>
      <Typography variant="body2">
        <Typography variant="subtitle2" component="span">
          Type:
        </Typography>{' '}
        {activityType?.name}
      </Typography>
      <Typography variant="body2">
        <Typography variant="subtitle2" component="span">
          Owner:
        </Typography>{' '}
        {owner}
      </Typography>
      <Typography variant="body2" mt={1}>
        <Typography variant="subtitle2" component="span">
          Start Date:
        </Typography>{' '}
        {startDate}
      </Typography>
      <Typography variant="body2">
        <Typography variant="subtitle2" component="span">
          Due Date:
        </Typography>{' '}
        {dueDate}
      </Typography>
      {current && current.description && (
        <Typography variant="body2" mt={1}>
          <Typography variant="subtitle2" component="span">
            Description:
          </Typography>{' '}
          {current.description}
        </Typography>
      )}
    </Box>
  )
}
